








import _ from 'lodash';
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class DataFilter extends Vue {
  public onFilter: any;

  @Prop() private value!: string;
  @Prop() private translate!: {};

  public created() {
    this.onFilter = _.debounce((e: any) => this.$emit('input', e.target.value) as any, 250);
  }
}
